import { FC } from 'react';

import { RowCell } from 'modules/_shared/Table/types/RowCell';
import TableRow from 'modules/_shared/Table/components/TableRow';

import { PartnerData } from '../types/PartnerData';

type Props = {
  index: number;
  partner: PartnerData;
};

const PartnersTableViewRow: FC<Props> = ({ index, partner }: Props) => {
  const partnerName = partner.name;
  const partnerEmail = partner.email;

  const cells = [
    {
      key: `partner-name-${index}`,
      content: <span className="title">{partnerName}</span>,
    },

    {
      key: `partner-email-${index}`,
      content: <span className="title d-block">{partnerEmail}</span>,
    },
  ].filter(Boolean) as RowCell[];

  return <TableRow cells={cells} />;
};

export default PartnersTableViewRow;
